// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

// Main project Config
export const firebaseConfig = {
  apiKey: "AIzaSyAp1PbccrrXgw8zgV4XGr9eFmLsOH4kzWc",
  authDomain: "testing-43dea.firebaseapp.com",
  databaseURL: "https://testing-43dea-default-rtdb.firebaseio.com",
  projectId: "testing-43dea",
  storageBucket: "testing-43dea.appspot.com",
  messagingSenderId: "797930325438",
  appId: "1:797930325438:web:4540380030af5984b665ef",
  measurementId: "G-TM82JXFXSY",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
